export default __webpack_public_path__ + "static/media/sec-1-top.8bf30849.png";